import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultas-externas-public',
  templateUrl: './consultas-externas-public.component.html',
  styleUrls: ['./consultas-externas-public.component.scss']
})
export class ConsultasExternasPublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
